import React, { useEffect, useState, useContext, useCallback, useRef, Fragment } from 'react'
import '../css/sb-admin-2.min.css'
import '../css/sb-admin-2.css'

import icocopyadd from '../img/ico-copyadd.png'
import icodelete from '../img/ico-delete.png'
import icoedit from '../img/ico-edit.png'

import $ from 'jquery';
import { AppColors } from '../css/AppColors';
import { apiRequest } from '../utils/apiCalls';
import { Modal, Button, Form } from 'react-bootstrap';
import Sidebar from '../Components/Sidebar';
import Topbar from '../Components/Topbar';
import { Context } from '../Context/DataContext';
import { FaClipboardList, FaPencilAlt, FaTrash } from 'react-icons/fa'
import { Link, useLocation } from 'react-router-dom';


const useForceUpdate = () => {
    const [, updateState] = React.useState();
    return React.useCallback(() => updateState({}), []);
}


const ManagePrescription = () => {
    const forceUpdate = useForceUpdate();
    var location = useLocation();

    const [presc, setPresc] = useState([])
    const [loading, setLoading] = useState(false)
    const [cust_id, setCustId] = useState(location?.state ? location.state : '');
    const [customer, setCustomer] = useState();

    const [delPrescId, setDelPrescId] = useState('')
    const [delPrescModal, setDelPrescModal] = useState(false)

    const { state, setCustomersGlobal } = useContext(Context)
    const [storeCustomers, setStoreCustomers] = useState(state.customers ? state.customers : [])


    const [value, setValue] = useState(location?.state?.cust_fname ? location.state.cust_fname + " " + location.state.cust_lname : "");
    const [showDropdown, setShowDropdown] = useState(false);
    const wrapperRef = useRef(null);
    const [suggestionArr, setSuggestionArr] = useState([])


    function getPresc() {

        setLoading(true)

        console.log('cust id = ')
        console.log(cust_id)
        apiRequest({ cust_id: cust_id }, 'viewpresc')
            .then(data => {
                setLoading(false)
                if (data.status == '1') {
                    setPresc(data.data)
                }
                else {
                    setPresc([])
                    // alert(data.error)
                }
            })
            .catch(err => {
                alert("Internet Error")
            })
    }

    function delPresc() {

        const reqObj = {
            id: delPrescId,
            cust_id: cust_id
        }
        console.log(reqObj)
        setLoading(true)
        apiRequest(reqObj, 'delpresc')
            .then(data => {
                console.log(data)
                if (data.status == '1') {
                    if (data.data) {
                        setLoading(false)
                        setPresc(data.data)
                        // alert(data.msg)
                    }
                    else {
                        setPresc([])
                        setLoading(false)
                        alert(data.msg)
                    }
                }
                else {
                    setLoading(false)
                    alert(data.error)
                }
            })
            .catch(err => {
                setLoading(false)
                alert('Internet Error')
            })


    }

    function getCustomers() {

        setLoading(true)
        var st_id;
        st_id = state.storeData.st_id
        apiRequest({ st_id: st_id }, 'viewcustomers')
            .then(data => {
                setLoading(false)
                if (data.status == 1) {
                    setStoreCustomers(data.data)
                    setCustomersGlobal(data.data)
                    forceUpdate();
                }

            })
            .catch(err => {
                setLoading(false)
                console.log(err)
            })
    }





    useEffect(() => {

        $(document).ready(function () {
            $('#dataTable').DataTable();
        });
    }, [loading])


    useEffect(() => {

        console.log('location . state')
        console.log(location.state)
        if (cust_id) {
            getPresc();
        }
        if (!state.customers.length) getCustomers();
        else {
            console.log('filter is')
            if (cust_id) {
                const result = storeCustomers.filter(word => cust_id == word.cust_id);
                if (result.length) {
                    setCustomer(result[0])
                    console.log('filter  = ')
                    console.log(result)
                    setValue(result[0].cust_fname + " " + result[0].cust_lname)
                    forceUpdate();
                }

            }

            // storeCustomers.filter(v=>)
        }

        return () => {
            location.state = null
        }

    }, [cust_id])
    return (

        <div
            onClick={() => setSuggestionArr([])}
            id="page-top">
            <div id="wrapper" >
                <Sidebar />



                <div id="content-wrapper" class="d-flex flex-column">
                    <div id="content">
                        <Topbar />

                        <Modal
                            show={delPrescModal}
                            onHide={() => setDelPrescModal(false)}
                        >
                            <Modal.Header>
                                <Modal.Title style={{ fontSize: 18, textAlign: 'center', alignSelf: 'center', fontFamily: 'PSBo' }} >Are you sure you want to delete this prescription?</Modal.Title>
                            </Modal.Header>
                            <Modal.Footer>
                                <Button
                                    style={{ fontFamily: 'PMe' }}
                                    variant="secondary" onClick={() => {
                                        setDelPrescId('')
                                        setDelPrescModal(false)
                                    }}>No</Button>
                                <Button
                                    style={{ fontFamily: 'PMe' }}
                                    variant="danger" onClick={() => {
                                        setDelPrescModal(false)
                                        delPresc()
                                    }}>Yes</Button>
                            </Modal.Footer>


                        </Modal>

                        <Modal
                            show={loading}
                        >

                            <Modal.Body class="text-center" >
                                <div
                                    class="text-center"
                                    class="spinner-border text-center" style={{ margin: 10, color: AppColors.primary }} role="status"></div>
                            </Modal.Body>

                        </Modal>
                        <div className="container-fluid" >
                            <div className="d-sm-flex align-items-center justify-content-between mb-4">
                                <h1 className="h3 mb-0 text-gray-800">Manage Prescription</h1>
                            </div>
                            {/* {
                                !location?.state || !presc.length ? */}
                            <div class="row mt-2 mb-3 col-12 ">
                                {
                                    cust_id && presc.length ?

                                        <div className="col-sm-6">
                                            <Button
                                                className="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm "
                                                style={{ color: 'white', backgroundColor: AppColors.primary, borderWidth: 0, marginTop: 10, fontFamily: 'RBo', }}

                                            >
                                                <Link
                                                    style={{ color: 'white', textDecorationLine: 'none', }}
                                                    to={{
                                                        pathname: "/addOrder",
                                                        state: {
                                                            cust: customer
                                                        }
                                                    }}
                                                >
                                                    Add Order
                                                </Link>
                                            </Button>
                                        </div>
                                        : null
                                }
                            </div>
                            {/* <div className="col-sm-6">
                                    <Form.Select
                                        className="col-sm-6 mb-3 mb-sm-0 col-sm-12" size="md"
                                        onChange={(v) => {

                                            let obj = v.target.value
                                            obj = JSON.parse(obj)
                                            setCustId(obj.cust_id)
                                            setCustomer(obj)
                                        }}
                                    >
                                        {
                                            !cust_id &&
                                            <option selected disabled={true}>Select Customer</option>
                                        }
                                        {
                                            storeCustomers?.map((v, i) => {
                                                return (
                                                    <>

                                                        {
                                                            <option selected={cust_id == v.cust_id ? true : false} value={JSON.stringify(v)}>{v.cust_fname} {v.cust_lname}</option>
                                                        }

                                                    </>
                                                )
                                            })
                                        }
                                    </Form.Select>

                                </div> */}
                            <div
                                // onClickCapture={() => { return null }}
                                className="input__wrapper" ref={wrapperRef}>
                                <input
                                    type="text"
                                    style={{ fontFamily: 'PRe' }}
                                    placeholder={value ? value : "Search Customer"}
                                    className="form-control form-control-user"
                                    onChange={(v) => {
                                        var val = v.target.value
                                        setValue(val)
                                        // console.log('val =' + val)
                                        if (!val.length) {
                                            // setOrders(orderArr)
                                            return
                                        }
                                        try {
                                            var search = new RegExp(val, 'i'); // prepare a regex object
                                        }
                                        catch (err) {
                                            console.log(err)
                                        }
                                        var c = [];
                                        var i = 0;
                                        for (let key in storeCustomers) {
                                            if (val.indexOf(' ') >= 0) {
                                                try {
                                                    if (search.test(storeCustomers[key].cust_fname + " " + storeCustomers[key].cust_lname)) {
                                                        c[i] = storeCustomers[i]
                                                    }
                                                }
                                                catch (err) { }

                                            }
                                            try {
                                                if (search.test(storeCustomers[key].cust_fname) || search.test(storeCustomers[key].cust_lname) || search.test(storeCustomers[key].cust_phone)) {
                                                    c[i] = storeCustomers[i]
                                                }
                                            }
                                            catch (err) { }

                                            i++;
                                        }
                                        setSuggestionArr(c)
                                        forceUpdate()
                                    }}
                                    onFocus={() => {
                                        setShowDropdown(true)
                                        setSuggestionArr(storeCustomers)
                                        forceUpdate();
                                    }}

                                    value={value}
                                />
                                <div

                                    className="suggestions__dropdown">
                                    {suggestionArr?.length > 0 ? (
                                        <div style={{ position: 'fixed', zIndex: 1000, backgroundColor: 'rgba(128,128,128,1)', width: "50%", borderRadius: 5, padding: 10 }}>
                                            {suggestionArr.map((v, index) => {
                                                return (
                                                    <div style={{ marginTop: 0 }}>
                                                        <input
                                                            type="button"
                                                            style={{ width: "100%", textAlign: 'left', backgroundColor: 'rgba(128,128,128,1)', color: 'white', borderWidth: 0, fontFamily: 'PMe', fontSize: 14 }}
                                                            // title={v.cust_id}
                                                            onClick={function () {
                                                                setCustId(v.cust_id)
                                                                setCustomer(v)
                                                                setSuggestionArr([])
                                                                setValue(v.cust_fname + " " + v.cust_lname)
                                                                forceUpdate()
                                                            }}
                                                            value={v.cust_fname.toString() + " " + v.cust_lname + " - " + v.cust_phone}
                                                        // key={"suggestion_" + index}
                                                        // value=

                                                        />
                                                    </div>

                                                )
                                            })}
                                        </div >
                                    ) : (
                                        null

                                    )}
                                </div>
                            </div>



                            {/* : null */}

                            {
                                !loading && presc.length ?

                                    <div className="card shadow mb-4 mt-4 " style={{ width: "100%" }} >


                                        <div className="card-body">
                                            <div className="table-responsive">
                                                {/* table class="table table-bordered dt-responsive" id="dataTable" width="100%" cellspacing="0" */}

                                                <table
                                                    id="dataTable"
                                                    className="table table-striped table-bordered dt-responsive"
                                                    style={{ width: "100%" }}
                                                    cellSpacing={0}
                                                >
                                                    <thead>
                                                        <tr>
                                                            <th className="tRow" >Customer</th>
                                                            <th className="tRow" >Prescriber</th>
                                                            <th className="tRow">Prescription Date	</th>
                                                            <th className="tRow">Location</th>
                                                            {/* <th className="tRow">Copy as New</th> */}
                                                            <th className="tRow" style={{ alignSelf: 'center', textAlign: 'center' }} >Action</th>

                                                            {/* <th className="tRow">Edit</th>
                                                            <th className="tRow">Delete</th> */}

                                                        </tr>
                                                    </thead>
                                                    <tbody>

                                                        {
                                                            presc?.map((v) => {
                                                                return (
                                                                    <tr>
                                                                        <td className="tData">
                                                                            <nobr>{v.cust_fname} {v.cust_lname}</nobr>
                                                                        </td>
                                                                        <td className="tData">
                                                                            <nobr>{v.prescriber}</nobr>
                                                                        </td>
                                                                        <td className="tData">
                                                                            <nobr>{Date(v.prescription_date)}</nobr>
                                                                        </td>
                                                                        <td className="tData">
                                                                            <nobr>{state.storeData.st_name}</nobr>
                                                                        </td>





                                                                        <td style={{ textAlign: 'center' }}>

                                                                            {/* <td className="tData"> */}
                                                                            <Link to=
                                                                                {{
                                                                                    pathname: '/addPresciption',
                                                                                    state: v
                                                                                }}
                                                                                className="tData btn" style={{ color: 'rgba(0,0,0,0.7)', fontSize: 15, fontFamily: 'RMe' }} >
                                                                                <img src={icocopyadd} />
                                                                            </Link>

                                                                            {/* </td> */}
                                                                            <Link to=
                                                                                {{
                                                                                    pathname: '/ViewSinglePresc',
                                                                                    state: v
                                                                                }}
                                                                                className="btn" style={{ backgroundColor: '#54C2BB' }} >
                                                                                <FaClipboardList color="white" />
                                                                            </Link>{" "}

                                                                            <Link to={{
                                                                                pathname: '/editPrescription',
                                                                                state: v

                                                                            }}
                                                                                className="btn" style={{ backgroundColor: '#54C2BB' }} >
                                                                                <FaPencilAlt color="white" />
                                                                            </Link>{" "}
                                                                            <Button
                                                                                onClick={() => {

                                                                                    setDelPrescId(v.id)
                                                                                    setDelPrescModal(true)
                                                                                    // delPresc(v.id)
                                                                                }} className="btn btn-danger del_product" id>
                                                                                <FaTrash color="white" />
                                                                            </Button>
                                                                        </td>

                                                                        {/* <td className="tData">
                                                                            <Link to=
                                                                                {{
                                                                                    pathname: '/editPrescription',
                                                                                    state: v
                                                                                }}
                                                                                className="tData" style={{ color: 'rgba(0,0,0,0.7)', fontSize: 15, fontFamily: 'RMe' }} >
                                                                                <img src={icoedit} />
                                                                            </Link>
                                                                        </td>
                                                                        <td className="tData">
                                                                            <Button
                                                                                variant="outline-none"
                                                                                onClick={() => {
                                                                                    
                                                                                }}
                                                                            >
                                                                                <img src={icodelete} />
                                                                            </Button>

                                                                        </td> */}
                                                                    </tr>
                                                                )
                                                            })
                                                        }


                                                    </tbody>
                                                </table>

                                            </div>
                                        </div>


                                    </div>
                                    : !loading && cust_id && <div>
                                        <div className="d-sm  align-items-center justify-content-center mb-4 mt-4" style={{ textAlign: 'center' }}>
                                            <h3 className="h5 mb-0 text-gray-800" style={{ color: 'grey', fontSize: 18 }}>No prescription added yet</h3>
                                            <br></br>
                                            <Button
                                                style={{ color: 'white', backgroundColor: AppColors.primary, borderWidth: 0, fontFamily: 'RBo', }}
                                            // onClick={() => { console.log(location.state) }}
                                            >
                                                <Link
                                                    style={{ color: 'white', textDecorationLine: 'none' }}
                                                    to={{

                                                        pathname: "/addPresciption",
                                                        state: customer
                                                        // {
                                                        //     cust_id
                                                        // }
                                                    }}
                                                >
                                                    Click to add
                                                </Link>
                                            </Button>
                                        </div>

                                    </div>
                            }



                        </div>
                    </div>
                </div>
            </div >
        </div >

    )
}

export default ManagePrescription
